<template>
    <div>
    <div id="quick_register">
        <van-icon name="cross" class="pop_close" @click="close"></van-icon>
        <div class="web-logo"></div>
        <p class="txt txt1">欢迎使用G买卖交易平台</p>
        <div class="phone_num">
            <div class="phone">{{ maskedPhone }}</div>
        </div>
        <p class="txt txt2">使用盒子手机号注册G买卖</p>
        <div class="bottom">
            <div class="check">
                <van-popover v-model="showPopover" placement="top-start" get-container=".check">
                    <div class="check_popover">注册前请先勾选</div>
                </van-popover>
                <el-checkbox v-model="agree">同意 <span @click.prevent="gotoTarget(0)">《用户协议》</span>、
                    <span @click.prevent="gotoTarget(1)">《隐私政策》</span>、
                    <span @click.prevent="gotoTarget(2)">《儿童个人信息保护规则及监护人须知》</span>和
                    <span @click.prevent="gotoTarget(3)">《第三方服务共享清单》</span>
                </el-checkbox>
            </div>
            <el-button class="login_btn" :loading="loading" @click="login">一键注册</el-button>
        </div>
    </div>
    <div class="agreement_full" v-if="showAgreement">
        <div class="full_header">
            <van-icon name="arrow-left" class="back" @click="closeAgreement" />
            <span class="tit">{{ titles[agreementIndex] }}</span>
        </div>
        <div class="full_body">
            <component :is="currentAgreement" />
        </div>
    </div>
    </div>
</template>
<script>
export default {
    props: ['selection'],
    data() {
        return {
            showPopover: false,
            agree: false,
            list: ["agreement", "policy", "children", "thirdparty"],
            loading: false,
            showAgreement: false,
            agreementIndex: 0,
            titles: ['用户协议','隐私政策','儿童个人信息保护规则及监护人须知','第三方服务共享清单']
        }
    },
    computed: {
        maskedPhone() {
            const str = (this.selection && this.selection.phone) || ''
            if (str.length >= 7) {
                return str.substring(0, 3) + '****' + str.substring(str.length - 4)
            }
            return str
        },
        isAndroid() {
            var u = navigator.userAgent;
            if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
                return true
            } else {
                return false
            }
        },
        currentAgreement() {
            return [this.$options.components.Agreement, this.$options.components.Policy, this.$options.components.Children, this.$options.components.ThirdParty][this.agreementIndex]
        }
    },
    components: {
        Agreement: () => import('@/pages/user/agreements/Agreement'),
        Policy: () => import('@/pages/user/agreements/Policy'),
        Children: () => import('@/pages/user/agreements/Children'),
        ThirdParty: () => import('@/pages/user/agreements/ThirdParty'),
    },
    methods: {
        close() {
            this.$store.commit('setAutoLogin', false)
            this.$emit('handleClose')
        },
        gotoTarget(i) {
            this.agreementIndex = i
            this.showAgreement = true
        },
        login() {
            if (!this.agree) {
                this.showPopover = true;
                return;
            }
            this.loading = true;
            this.$Ajax('user-info/login-by-39box', {
                token: this.selection.token,
            }).then(res => {
                this.loading = false;
                if (res.code == 200) {
                    this.$store.dispatch("setCookies", res.data);
                    const isAndroid = this.$store.getters.ua.isAndroid
                    if (isAndroid) {
                        try {
                            window.android.sendUserInfoWebToNative(JSON.stringify(res.data));
                        } catch (error) {
                            console.log(error);
                        }
                    } else {
                        try {
                            window.webkit.messageHandlers.sendUserInfoWebToNative.postMessage(JSON.stringify(res.data));
                        } catch (error) {
                            console.log(error);
                        }
                    }
                    this.$emit('handleSuccess')
                    this.$toast('登录成功');
                }
            }).finally(() => {
                setTimeout(() => {
                    this.loading = false;
                }, 2000);
            });
        },
        closeAgreement() {
            this.showAgreement = false
        }
    }
}
</script>
<style lang="less" scoped>
#quick_register {
    position: relative;
    padding: 1rem 2rem 2rem;

    .pop_close {
        position: absolute;
        font-size: 2.4rem;
        font-weight: 700;
        right: 1.2rem;
        top: 1rem;
        cursor: pointer;
    }

    .web-logo {
        width: 10rem;
        height: 5rem;
        margin: 0 auto 1rem;
        background: url('../../assets/bx/login_logo.png') no-repeat center 0;
        background-size: 100% auto;
    }

    .txt {
        text-align: center;
        font-size: 1.2rem;

        &.txt1 {
            margin-bottom: 2rem;
        }

        &.txt2 {
            margin-bottom: 1.8rem;
        }
    }

    .phone_num {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.6rem;
        margin: 1rem 0;
        width: 100%;
        padding: 1.2rem 2rem;
        border-radius: 0.6rem;
        background-color: #ccc;
        position: relative;

        &::before {
            content: '+86';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 2rem;
            font-size: 1.6rem;
            color: #666;
        }
    }

    .check {
        overflow: hidden;

        /deep/.el-checkbox {
            align-items: flex-start;

            .el-checkbox__label {
                font-size: 1.3rem;
                line-height: 1.8rem;

                span {
                    color: var(--theme);
                }
            }
        }
    }

    .login_btn {
        margin-top: 2.2rem;
        width: 100%;
        text-align: center;
        padding: 1.2rem 0;
        color: #fff;
        background-color: #333;
        font-size: 1.4rem;
        border-radius: 10rem;
    }
}

.agreement_full {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 525px;
    height: 100%;
    z-index: 10002;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    .full_header {
        height: 5rem;
        line-height: 5rem;
        background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
        background-color: #fff;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .back {
            position: absolute;
            left: 1rem;
            top: 50%;
            transform: translateY(-50%);
            font-size: 2rem;
            cursor: pointer;
            color: #fff;
        }
        .tit {
            font-size: 1.6rem;
            color: #fff;
        }
    }
    .full_body {
        flex: 1;
        overflow: auto;
        padding: 1rem;
    }
}
</style>
